export const getMaxAllowedCampaignNameChars = (campaignName, customName, asNumber: boolean) => {
    const max = 60 - (campaignName?.length || 0);
    return asNumber ? max : `${customName?.length || 0}/${max}`;
}